<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        icon
        :color="!internal || localSchedule.selfieWallEmbedCode ? 'primary' : 'grey lighten-2'"
        @click="editValue()"
      >
        <v-icon>mdi-badge-account</v-icon>
      </v-btn>
    </template>
    <span>{{ $t("admin.activities.edit.wallEmbed.hint") }}</span>
    <v-dialog :persistent="internal" v-model="selfieWallEmbedCodeDialog" max-width="500">
      <v-card>
        <v-card-text class="pt-2">
          <v-form
            ref="selfieWallEmbedCodeForm"
            v-model="isFormValid"
            @submit.prevent="saveScheduleWallModal()"
            class="mx-4 my-2"
          >
            <v-text-field
              v-model="model.hashtag"
              :label="$t('admin.activities.edit.wallEmbed.hashtag')"
              :rules="[$v.required(), $v.maxLength(255)]"
              prepend-inner-icon="mdi-pound"
              prepend-icon="mdi-"
            ></v-text-field>
            <v-text-field
              v-model="model.fbLink"
              :label="$t('admin.activities.edit.wallEmbed.social.facebook')"
              :rules="[$v.isUrl(), $v.maxLength(255)]"
              prepend-icon="mdi-facebook"
            ></v-text-field>
            <v-text-field
              v-model="model.instagramLink"
              :label="$t('admin.activities.edit.wallEmbed.social.instagram')"
              :rules="[$v.isUrl(), $v.maxLength(255)]"
              prepend-icon="mdi-instagram"
            ></v-text-field>
            <v-text-field
              v-model="model.twitterLink"
              :label="$t('admin.activities.edit.wallEmbed.social.twitter')"
              :rules="[$v.isUrl(), $v.maxLength(255)]"
              prepend-icon="mdi-twitter"
            ></v-text-field>
            <div v-if="internal">
              <v-btn :disabled="!isFormValid" color="primary" elevation="0" type="submit">
                <v-icon>mdi-open-in-app</v-icon>
                Save
              </v-btn>
              <v-btn @click="closeScheduleWallModal()" class="ml-1" elevation="0">
                <v-icon>mdi-close</v-icon>
                Cancel
              </v-btn>
            </div>
            <div v-else>
              <v-textarea
                ref="embedCodeArea"
                outlined
                v-bind:disabled="!copyingOngoing"
                name="input-7-4"
                v-model="embedCode"
              ></v-textarea>
              <v-btn :disabled="!isFormValid" color="primary" elevation="0" type="submit">
                <v-icon>mdi-content-copy</v-icon>
                Copy
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-tooltip>
</template>

<script>
export default {
  name: "ActivitiesEditWallModal",
  props: {
    schedule: Object,
    activityId: {
      type: Number,
      default: null,
      required: false,
    },
    internal: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      selfieWallEmbedCodeDialog: false,
      isFormValid: false,
      copyingOngoing: false,
      model: {
        fbLink: null,
        twitterLink: null,
        instagramLink: null,
        hashtag: null,
      },
    };
  },
  methods: {
    closeScheduleWallModal() {
      this.selfieWallEmbedCodeDialog = false;
      this.$refs.selfieWallEmbedCodeForm.resetValidation();
      this.model = {
        fbLink: null,
        twitterLink: null,
        instagramLink: null,
        hashtag: null,
      };
    },
    saveScheduleWallModal() {
      if (this.internal) {
        this.localSchedule.selfieWallEmbedCode = JSON.stringify(this.model);
        this.closeScheduleWallModal();
      } else {
        this.copyText();
      }
    },
    copyText() {
      this.copyingOngoing = true;
      setTimeout(() => {
        let textToCopy = this.$refs.embedCodeArea.$el.querySelector("textarea");
        textToCopy.select();
        document.execCommand("copy");
        this.copyingOngoing = false;
        this.closeScheduleWallModal();
      });
    },
    editValue() {
      if (this.internal) {
        if (this.localSchedule.selfieWallEmbedCode) {
          this.localSchedule.selfieWallEmbedCode = null;
        } else {
          this.selfieWallEmbedCodeDialog = true;
        }
      } else {
        this.selfieWallEmbedCodeDialog = true;
      }
    },
  },
  computed: {
    wallSrc() {
      let src = `${window.location.origin}/wall/${this.activityId}`;
      if (this.model.hashtag) {
        src += `?hashtag=${this.model.hashtag}`;
      }
      if (this.model.fbLink) {
        src += `&facebook=${this.model.fbLink}`;
      }
      if (this.model.instagramLink) {
        src += `&instagram=${this.model.instagramLink}`;
      }
      if (this.model.twitterLink) {
        src += `&twitter=${this.model.twitterLink}`;
      }
      return src;
    },
    embedCode() {
      return `
      <iframe src="${this.wallSrc}" title="${this.model.hashtag}" width="100%" height="100%" frameBorder="0" style="min-height: 70vh;">
      </iframe>
      `;
    },
    localSchedule: {
      get() {
        return this.schedule;
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
};
</script>

<style scoped></style>
